// Deal project user
export const DEAL_PARTNER_STATUS_ACCEPTED = "Accepted";
export const DEAL_PARTNER_STATUS_NOT_INTERESTED = "Not Interested";
export const DEAL_PARTNER_STATUS_PENDING = "Pending";
export const DEAL_PARTNER_STATUS_APPROVED = "Approved";
export const DEAL_PARTNER_STATUS_DECLINED = "Declined";
export const DEAL_PARTNER_STATUS_REQUESTED = "Requested";
